import {
    BorderedGridItem,
    ReadonlyFieldLabel,
    ReadonlyFieldValue
} from '@containers/form-i9/styles';
import { createTranslationService } from '@services/factories';
import { cacheTranslations } from '@utils/cache-translations';
import { observer } from 'mobx-react';
import * as React from 'react';

interface AddressFields {
    streetAddress: string;
    apartmentNumber: string;
    city: string;
    state: string;
    zipCode: string;
}

enum AddressFieldTranslation {
    addressLabel = 'addressLabel',
    apartmentNumberLabel = 'apartmentNumberLabel',
    cityOrTownLabel = 'cityOrTownLabel',
    stateLabel = 'stateLabel',
    zipCodeLabel = 'zipCodeLabel'
}

type AddressFieldItemsComponent = React.FunctionComponent<{ fields: Readonly<AddressFields> }>;
const FormI9AddressFieldItems: AddressFieldItemsComponent = observer(({ fields }) => {
    const translations = cacheTranslations(
        createTranslationService(),
        AddressFieldTranslation,
        'addressFields'
    );

    return (
        <React.Fragment>
            <BorderedGridItem xs={12} sm={5}>
                <ReadonlyFieldLabel>{translations.addressLabel}</ReadonlyFieldLabel>
                <ReadonlyFieldValue>{fields.streetAddress}</ReadonlyFieldValue>
            </BorderedGridItem>
            <BorderedGridItem xs={3} sm={2}>
                <ReadonlyFieldLabel>{translations.apartmentNumberLabel}</ReadonlyFieldLabel>
                <ReadonlyFieldValue>{fields.apartmentNumber}</ReadonlyFieldValue>
            </BorderedGridItem>
            <BorderedGridItem xs={4} sm={2}>
                <ReadonlyFieldLabel>{translations.cityOrTownLabel}</ReadonlyFieldLabel>
                <ReadonlyFieldValue>{fields.city}</ReadonlyFieldValue>
            </BorderedGridItem>
            <BorderedGridItem xs={2} sm={1}>
                <ReadonlyFieldLabel>{translations.stateLabel}</ReadonlyFieldLabel>
                <ReadonlyFieldValue>{fields.state}</ReadonlyFieldValue>
            </BorderedGridItem>
            <BorderedGridItem xs={3} sm={2}>
                <ReadonlyFieldLabel>{translations.zipCodeLabel}</ReadonlyFieldLabel>
                <ReadonlyFieldValue>{fields.zipCode}</ReadonlyFieldValue>
            </BorderedGridItem>
        </React.Fragment>
    );
});

export default FormI9AddressFieldItems;



// WEBPACK FOOTER //
// ./src/containers/form-i9/address-field-items.tsx